function passwordShow() {
    const passwordShowTrigger = document.querySelector("[data-component='password-show']");

    if (passwordShowTrigger !== null){
        var x = document.getElementById("passwordField");
        if (x.type === "password") {
            x.type = "text";
        } else {
            x.type = "password";
        }
    }
}

export default passwordShow();
